// Migrated
// Translated
<template>
  <InfoSection
    :icon="icons.faClock"
    :title="$t('departureTimes')"
    title-key="departureTimes"
    :text="trip.departure_info"
    :text-translation-key="trip?.departure_info_translationkey"
    variant="background"
  />
</template>

<script>
import { faClock } from '@fortawesome/pro-regular-svg-icons'

export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      icons: {
        faClock,
      },
    }
  },
})
</script>
